import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../constants/colors";

type Props = {
  onClick?: () => void;
};

export const CloseButton: React.FC<Props> = ({ onClick }) => {
  return (
    <CloseButtonContainer onClick={onClick}>
      <VerticalLine />
      <HorizontalLine />
    </CloseButtonContainer>
  );
};

const CloseButtonContainer = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 25px;
  height: 25px;
  cursor: pointer;
`;

const VerticalLine = styled.div`
  position: absolute;
  top: 0;
  left: 12px;
  display: block;
  width: 1px;
  height: 25px;
  background-color: ${BASIC_DARK_GRAY};
  transform-origin: center center;
  transform: rotate(45deg);
`;

const HorizontalLine = styled.div`
  position: absolute;
  top: 12px;
  left: 0;
  display: block;
  width: 25px;
  height: 1px;
  background-color: ${BASIC_DARK_GRAY};
  transform-origin: center center;
  transform: rotate(45deg);
`;
